import { AffectedResourceDto } from "@lib/ShiOneClient";

export interface AffectedScope {
  scopeId?: string;
  affectedResources?: AffectedResourceDto[];
}

export interface AwsRecommendationSummary {
  recommendationId: string;
  recommendationTypeId?: string;
  customerId?: string;
  category?: string;
  impact?: string;
  problem?: string;
  solution?: string;
  impactedField?: string;
  affectedScopes?: AffectedScope[];
  totalAffectedScopes?: number;
  totalAffectedResources?: number;
  accountId?: number;
  isLinkedToRoadmap?: boolean;
  roadmapName?: string;
  sourceId?: string;
  sourceSystem?: string;
  sourceType?: string;
  sourceMetadata?: any;
}

export const recommendationCloudPlatforms = {
  Azure: "Azure",
  AWS: "AWS",
};

export const recommendationSourceSystems = {
  Assessments: "Assessments",
  AzureSimpleRecommendations: "AzureSimpleRecommendations",
  AwsSavingsPlansPurchase: "AWSSavingsPlansPurchase",
  AwsReservationPurchase: "AWSReservationPurchase",
  AwsRightsizing: "AWSRightsizing",
  AwsSecurityCompliance: "AWSSecurityCompliance",
};

export const cloudPlatformSourceSystems = [
  recommendationSourceSystems.AzureSimpleRecommendations,
  recommendationSourceSystems.AwsSavingsPlansPurchase,
  recommendationSourceSystems.AwsReservationPurchase,
  recommendationSourceSystems.AwsRightsizing,
  recommendationSourceSystems.AwsSecurityCompliance,
];

export const awsCloudSourceSystems = [
  recommendationSourceSystems.AwsSavingsPlansPurchase,
  recommendationSourceSystems.AwsReservationPurchase,
  recommendationSourceSystems.AwsRightsizing,
  recommendationSourceSystems.AwsSecurityCompliance,
];

export const awsSourceSystemChipTitles: { [key: string]: string } = {
  AWSSavingsPlansPurchase: "Savings Plans",
  AWSReservationPurchase: "Reservations",
  AWSRightsizing: "Rightsizing",
  AWSSecurityCompliance: "Security & Compliance",
};

export const impactLabel: { [key: string]: string } = {
  high: "High Impact",
  medium: "Medium Impact",
  low: "Low Impact",
};
